import React from 'react';
import { PageHero } from '../components/PageHero';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { Link } from 'react-router-dom';
export function FaqsPage() {
  return <>
      <PageHero label="Support" title="Frequently Asked Questions" subtitle="Comprehensive answers to common queries about procurement, manufacturing, and logistics." data-id="element-700" />
      <Breadcrumbs items={[{
      label: 'Support'
    }, {
      label: 'FAQs'
    }]} data-id="element-701" />

      <section className="bg-white py-24" data-id="element-702">
        <div className="max-w-3xl mx-auto px-6 lg:px-8 text-center" data-id="element-703">
          <h2 className="text-2xl font-bold text-navy-900 mb-4" data-id="element-704">
            Full FAQ Database
          </h2>
          <p className="text-steel-600 mb-8" data-id="element-705">
            We are currently compiling a comprehensive database of frequently
            asked questions to better support our partners. In the meantime,
            please contact our team directly for any specific enquiries.
          </p>
          <Link to="/contact" className="inline-flex items-center justify-center px-8 py-3 bg-cg-orange-600 hover:bg-cg-orange-500 text-white font-bold uppercase tracking-wider rounded-sm transition-colors" data-id="element-706">
            Contact Support
          </Link>
        </div>
      </section>
    </>;
}